import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  AppLanguage,
  LANGUAGE_STORAGE_KEY,
  LANGUAGE_LABELS,
  resolveSupportedLanguage,
  SUPPORTED_LANGUAGES
} from "@assessment/i18n/languages";
import { setStoredAuthoringLanguage } from "@lxp-app/utils/authoringLibraryResources/authoringLibraryLanguages";
import { RootState } from "@lxp-app/store/store";
import { UserInfoSliceActions } from "@lxp-app/store/slices/userInfoSlice";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const userProfile = useSelector(
    (state: RootState) => state.UserInfoSlice.profile
  );

  const selectedLanguage =
    resolveSupportedLanguage(i18n.resolvedLanguage || i18n.language) || "en";

  const onChangeLanguage = (event: ChangeEvent<HTMLSelectElement>) => {
    const nextLanguage = event.target.value as AppLanguage;

    if (typeof window !== "undefined") {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
    }

    setStoredAuthoringLanguage(nextLanguage);

    if (userProfile) {
      dispatch(
        UserInfoSliceActions.setUser({
          ...userProfile,
          preferences: {
            ...userProfile.preferences,
            language: nextLanguage
          }
        })
      );
    }

    void i18n.changeLanguage(nextLanguage);
  };

  return (
    <label className="inline-flex items-center gap-2 text-sm font-medium text-secondary w-full">
      <span>{t("common.language")}</span>
      <select
        value={selectedLanguage}
        onChange={onChangeLanguage}
        aria-label={t("common.language")}
        className="rounded-md border border-secondary/20 bg-bkg px-2 py-1 text-sm font-medium text-secondary w-full"
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <option key={language} value={language}>
            {LANGUAGE_LABELS[language]}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
